/*
  Hof-Consent · Theme-Anbindung (Silver Edition Alpakas)

  Vertrag: docs/spec/hof-consent.md, Abschnitt 5 (Repo alpakalender). Kanonische Kopie:
  shopify-theme/hof-consent/assets/hof-consent-theme.js. Geladen in layout/theme.liquid mit defer
  vor global.js, damit g-map, Videos und "Zuletzt angesehen" darauf zugreifen können.

  Das Theme fragt die Einwilligung direkt bei der Shopify Customer Privacy API ab. Deshalb
  funktioniert es mit Consentmo (heute) genauso wie mit Hof-Consent (nach dem Go-live). Mit Hof-Consent
  muss zusätzlich HofConsent.erlaubt("komfort") zustimmen (siehe hofConsentLaesstZu).

  window.hofConsentTheme = {
    bereit,                  // Promise: erfüllt, sobald die Shopify-API geladen ist (oder feststeht, dass sie fehlt)
                             // UND die Seite fertig geparst ist (dann sind alle defer-Skripte gelaufen, auch Hof-Consent)
    komfort(),               // true, wenn "Komfort & externe Inhalte" (Shopify: preferences) erlaubt ist und, mit
                             // Hof-Consent, auch HofConsent.erlaubt("komfort"); false, solange unbekannt
    beiAenderung(fn),        // fn(komfort) bei jeder Änderung; gibt eine Funktion zum Abmelden zurück
    kannKomfortErlauben(),   // true, wenn komfortErlauben() wirken kann (Hof-Consent mit erlaube() da, API geladen, nicht im Editor)
    komfortErlauben(quelle)  // über HofConsent.erlaube("komfort", quelle): Promise<boolean>
  };

  Außerdem:
  - Klick auf [data-hof-consent-open] ohne Hof-Consent: öffnet die Einstellungen von Consentmo, sonst
    führt er zur Datenschutzerklärung (mit Hof-Consent öffnet dessen eigener Klick-Horcher den Dialog).
  - Der Kasten auf der Datenschutzseite ([data-hof-consent-kasten], im HTML hidden) wird nur gezeigt,
    wenn sich Einstellungen öffnen lassen (Hof-Consent mit geladener API oder Consentmo).
  - Ohne Komfort-Zustimmung löscht das Skript die Browser-Einträge aus NUR_MIT_KOMFORT, sobald das
    feststeht (API geladen oder ausdrückliche Ablehnung bzw. Widerruf).
*/
(function () {
  'use strict';

  if (window.hofConsentTheme) return;

  // Browser-Einträge des Themes, die nur mit Komfort-Zustimmung bestehen dürfen.
  var NUR_MIT_KOMFORT = ['beyours:recently-viewed'];
  var DATENSCHUTZ_PFAD = 'policies/privacy-policy';
  var WARTEZEIT_API = 8000;

  var komfortErlaubt = false; // Stand von Shopify (preferences)
  var gemeldet = false; // zuletzt an die Horcher gemeldeter Wert von komfort()
  var horcher = [];

  function api() {
    var shopify = window.Shopify;
    var cp = shopify && shopify.customerPrivacy;
    return cp && typeof cp.preferencesProcessingAllowed === 'function' ? cp : null;
  }

  function lesen() {
    var cp = api();
    if (!cp) return false;
    try {
      return cp.preferencesProcessingAllowed() === true;
    } catch (fehler) {
      return false;
    }
  }

  function editor() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  function komfortSpeicherLeeren() {
    NUR_MIT_KOMFORT.forEach(function (schluessel) {
      try {
        window.localStorage.removeItem(schluessel);
      } catch (fehler) {
        // Speicher gesperrt (z. B. privater Modus): nichts zu löschen
      }
    });
  }

  // Mit Hof-Consent muss auch HofConsent.erlaubt("komfort") zustimmen. Das ist false, solange die Einbettung die API
  // noch lädt, und vom Start eines Resets (neue Version, älter als 365 Tage, Zustimmung aus Consentmo) bis zur nächsten
  // Wahl, auch solange Shopify noch die alte Zustimmung meldet (Spec 3.2.4). So lädt die Karte nie mit der alten
  // Zustimmung, auch wenn die API hier vor dem Reset ankommt. Steht die Einbettung (#hof-consent) schon im Dokument,
  // ihr Skript ist aber noch nicht gelaufen oder lädt nicht, gilt bis dahin ebenfalls nichts. Ohne Hof-Consent
  // (Consentmo) zählt nur Shopify, wie bisher.
  function hofConsentLaesstZu() {
    var hofConsent = window.HofConsent;
    if (hofConsent && typeof hofConsent.erlaubt === 'function') {
      try {
        return hofConsent.erlaubt('komfort') === true;
      } catch (fehler) {
        return false;
      }
    }
    return !document.getElementById('hof-consent');
  }

  function komfort() {
    return komfortErlaubt && hofConsentLaesstZu();
  }

  // Horcher nur bei echten Änderungen von komfort()
  function melden() {
    var wert = komfort();
    if (wert === gemeldet) return;
    gemeldet = wert;
    horcher.slice().forEach(function (fn) {
      try {
        fn(wert);
      } catch (fehler) {
        console.error(fehler);
      }
    });
  }

  // sicher = der Wert kommt von der geladenen API oder aus einer ausdrücklichen Wahl. Nur dann wird gelöscht,
  // damit eine nicht geladene API (Inhaltsblocker, Netzfehler) keine Liste eines zustimmenden Gastes löscht.
  // Gelöscht wird nach dem Stand von Shopify, nicht nach Hof-Consent: Lädt die Einbettung noch, bleibt die Liste.
  function setzen(wert, sicher) {
    komfortErlaubt = wert === true;
    if (!komfortErlaubt && sicher) komfortSpeicherLeeren();
    melden();
  }

  // fn genau einmal, sobald die Seite fertig geparst ist. DOMContentLoaded kommt erst nach allen defer-Skripten,
  // also auch nach der Hof-Consent-Einbettung am Ende von <body>; readyState ist dort schon "interactive" und
  // taugt deshalb nicht. "load" fängt den Fall ab, dass dieses Skript erst nach DOMContentLoaded läuft.
  function nachDemParsen(fn) {
    var erledigt = false;
    function einmal() {
      if (erledigt) return;
      erledigt = true;
      fn();
    }
    if (document.readyState === 'complete') {
      einmal();
      return;
    }
    document.addEventListener('DOMContentLoaded', einmal);
    window.addEventListener('load', einmal);
  }

  // fertig() genau einmal: API geladen, Fehler oder spätestens nach WARTEZEIT_API. Eine spätere Antwort wird trotzdem übernommen.
  // Shopify.loadFeatures ist an dieser Stelle normalerweise schon da: content_for_header legt es als Warteschlange an
  // (Inline-Skript), die load_feature-….js (ein späteres defer-Skript) abarbeitet. Fehlt es trotzdem, wird nach dem
  // Parsen ein zweites Mal versucht; dann sind alle defer-Skripte gelaufen, auch der Lader von Shopify.
  function apiLaden(fertig) {
    var erledigt = false;
    var nochmal = true;

    function ende() {
      setzen(lesen(), Boolean(api()));
      if (erledigt) return;
      erledigt = true;
      fertig();
    }

    function versuchen() {
      try {
        if (api()) {
          ende();
          return;
        }
        if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (fehler) {
            if (fehler) console.warn('[Hof-Consent] Die Shopify-Einwilligungs-API ließ sich nicht laden.');
            ende();
          });
          window.setTimeout(ende, WARTEZEIT_API);
          return;
        }
      } catch (fehler) {
        console.warn('[Hof-Consent] Die Shopify-Einwilligungs-API ließ sich nicht laden.');
        ende();
        return;
      }
      if (nochmal) {
        nochmal = false;
        nachDemParsen(versuchen);
        return;
      }
      ende();
    }

    versuchen();
  }

  var bereit = new Promise(function (erfuellen) {
    var offen = 2;
    function teil() {
      offen -= 1;
      if (offen === 0) erfuellen();
    }
    apiLaden(teil);
    nachDemParsen(teil);
  });

  // Shopify meldet jede Änderung, egal welches Banner sie ausgelöst hat (Consentmo oder Hof-Consent).
  document.addEventListener('visitorConsentCollected', function (ereignis) {
    var detail = ereignis && ereignis.detail;
    if (detail && typeof detail.preferencesAllowed === 'boolean') {
      setzen(detail.preferencesAllowed, true);
    } else {
      setzen(lesen(), Boolean(api()));
    }
  });

  document.addEventListener('hof-consent:geaendert', function (ereignis) {
    var detail = ereignis && ereignis.detail;
    if (detail && typeof detail.komfort === 'boolean') {
      setzen(detail.komfort, true);
    } else {
      setzen(lesen(), Boolean(api()));
    }
  });

  // Hof-Consent hat die API geladen und einen Reset, falls nötig, von Shopify beantwortet (auch wenn die API hier erst
  // nach WARTEZEIT_API ankommt): Stand noch einmal lesen. Erst ab hier kann komfort() mit Hof-Consent true werden.
  document.addEventListener('hof-consent:bereit', function () {
    setzen(lesen(), Boolean(api()));
  });

  function shopWurzel() {
    var routen = window.Shopify && window.Shopify.routes;
    var wurzel = (routen && routen.root) || '/';
    return wurzel.charAt(wurzel.length - 1) === '/' ? wurzel : wurzel + '/';
  }

  // "Karten immer laden" setzt Komfort über Hof-Consent (Spec 3.5): die Einbettung lässt die übrigen Bereiche,
  // wie sie sind, schreibt ihren lokalen Eintrag, zeigt die Statuszeile, schickt den Nachweis und speichert in der
  // Vorschau ("Hinweis immer zeigen") nichts. Ohne Hof-Consent gibt es diesen Weg nicht (die Karte lädt nur per Klick).
  function kannKomfortErlauben() {
    var hofConsent = window.HofConsent;
    return Boolean(!editor() && api() && hofConsent && typeof hofConsent.erlaube === 'function');
  }

  function komfortErlauben(quelle) {
    if (!kannKomfortErlauben()) return Promise.resolve(false);
    try {
      return Promise.resolve(window.HofConsent.erlaube('komfort', quelle || 'karte')).then(function (ok) {
        return ok === true;
      }, function () {
        return false;
      });
    } catch (fehler) {
      return Promise.resolve(false);
    }
  }

  window.hofConsentTheme = {
    bereit: bereit,
    komfort: komfort,
    beiAenderung: function (fn) {
      if (typeof fn !== 'function') return function () {};
      horcher.push(fn);
      return function () {
        var stelle = horcher.indexOf(fn);
        if (stelle !== -1) horcher.splice(stelle, 1);
      };
    },
    kannKomfortErlauben: kannKomfortErlauben,
    komfortErlauben: komfortErlauben
  };

  // Consentmo (bis zum Go-live): sein Einstellungsfenster, damit der Widerruf so einfach bleibt wie die Zustimmung.
  function consentmoOeffnen() {
    var consentmo = window.Consentmo;
    try {
      if (consentmo && typeof consentmo.openDialog === 'function') {
        consentmo.openDialog('preferences');
        return true;
      }
      if (typeof window.openCookieWidgetPopup === 'function') {
        window.openCookieWidgetPopup();
        return true;
      }
    } catch (fehler) {
      // Consentmo hat seine Schnittstelle geändert: weiter zur Datenschutzerklärung
    }
    return false;
  }

  function consentmoDa() {
    var consentmo = window.Consentmo;
    return Boolean((consentmo && typeof consentmo.openDialog === 'function') || typeof window.openCookieWidgetPopup === 'function');
  }

  // Rückfall ohne Hof-Consent: Consentmo öffnen, sonst zur Datenschutzerklärung. Mit Hof-Consent übernimmt dessen
  // Klick-Horcher (auch wenn dort die API fehlt: dann leitet die Einbettung selbst zur Datenschutzerklärung).
  document.addEventListener('click', function (ereignis) {
    if (window.HofConsent || ereignis.defaultPrevented) return;
    var ziel = ereignis.target && ereignis.target.closest ? ereignis.target.closest('[data-hof-consent-open]') : null;
    if (!ziel) return;
    ereignis.preventDefault();
    if (consentmoOeffnen()) return;
    if (window.location.pathname.indexOf('/' + DATENSCHUTZ_PFAD) !== -1) return;
    window.location.href = shopWurzel() + DATENSCHUTZ_PFAD;
  });

  // Der Kasten auf der Datenschutzseite steht im HTML mit hidden und erscheint nur, wenn er etwas öffnen kann.
  function kastenZeigen(sichtbar) {
    document.querySelectorAll('[data-hof-consent-kasten]').forEach(function (kasten) {
      kasten.hidden = !sichtbar;
    });
  }

  var kastenMitHofConsent = false;
  function kastenPruefen() {
    var hofConsent = window.HofConsent;
    if (hofConsent) {
      if (kastenMitHofConsent) return;
      kastenMitHofConsent = true;
      // Erst zeigen, wenn Hof-Consent bereit ist: Lädt die Customer Privacy API nicht, lässt sich nichts einstellen.
      if (hofConsent.bereit && typeof hofConsent.bereit.then === 'function') {
        hofConsent.bereit.then(function (ok) {
          kastenZeigen(ok !== false);
        }, function () {
          kastenZeigen(false);
        });
      } else {
        kastenZeigen(true);
      }
      return;
    }
    kastenZeigen(consentmoDa());
  }

  nachDemParsen(kastenPruefen);
  // Consentmo lädt sein Skript asynchron und ist bei DOMContentLoaded oft noch nicht da.
  window.addEventListener('load', kastenPruefen);
})();
